import React, { useEffect } from "react";
import { useSelector } from "react-redux";

export default function Showvehicle() {
  const ownerInfo = useSelector((state) => state?.addressdetail?.info3);

  return (
    <>
      <div className="d-flex px-3 row row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1">
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">Vehicle Registration No</div>
          <div className="indivtext">{ownerInfo?.bikeNumber}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">Registration Year</div>
          <div className="indivtext">{ownerInfo?.registrationYear}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">ENGINE NUMBER</div>
          <div className="indivtext">{ownerInfo?.Engine}</div>
        </div>
        <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
          <div className="indivtexthead">CHASSIS NUMBER</div>
          <div className="indivtext">{ownerInfo?.Chasis}</div>
        </div>
      </div>
    </>
  );
}
